import {useLocation} from 'react-router';

import {useMenuCurrentItem} from '@/components/menu';
import {useMenus} from '@/providers';

import {IToolbarPageTitleProps} from './types';
import {CommonHexagonBadge} from "@/partials/common";
import {KeenIcon} from "@/components";

const ToolbarPageTitle = ({text, icon, iconColor}: IToolbarPageTitleProps) => {
    const {pathname} = useLocation();
    const {getMenuConfig} = useMenus();
    const menuConfig = getMenuConfig('primary');
    const menuItem = useMenuCurrentItem(pathname, menuConfig);

    return (
        <div className="flex items-baseline space-x-2">
            <KeenIcon
                icon={icon ?? menuItem?.icon ?? "default-icon"}
                className={`text-3xl ${iconColor ?? menuItem?.iconColor ?? "default-color"}`}
            />
            <h1 className="text-xl font-semibold leading-none text-gray-900">{text ?? menuItem?.title}</h1>
        </div>
    );
};

export {ToolbarPageTitle};
